module.exports = __webpack_public_path__ + "img/pfolios.net.f0d48a84.png";